<template>
	<article class="ads-list--page">
		<ManagingSection class="search-by-enter__container" :columnCount="2">
			<ManagingBox title="노출영역">
				<select class="select" v-model="ad_code">
					<option
						v-for="item in parsedAdCodeList"
						:key="item.id"
						:value="item.id"
					>
						{{ item.name }}
					</option>
				</select>
			</ManagingBox>
			<ManagingBox title="검색어">
				<input
					v-model="keyword"
					type="text"
					placeholder="광고소재제목 or 참조ID"
					class="search-by-enter__target"
				/>
			</ManagingBox>
		</ManagingSection>
		<div class="btn-wrap-main">
			<button class="btn-main blue" type="button" @click="search">
				검색
			</button>
		</div>
		<ManagingSection :isTable="true">
			<table class="table-main">
				<thead>
					<tr>
						<th v-for="th in thList" :key="th">{{ th }}</th>
					</tr>
				</thead>
				<tbody v-if="parsedAds.length">
					<tr v-for="item in parsedAds" :key="item.id">
						<td>
							<button
								class="link"
								type="button"
								@click="
									viewAdDetailTotal(
										`${item.title} - ${item.adType}`,
										item.id
									)
								"
							>
								{{ item.id }}
							</button>
						</td>
						<td>
							<a
								class="link"
								@click.prevent.stop="
									linkTo(
										item.refId,
										item.refType,
										item.adCode
									)
								"
								>{{ item.title }}</a
							>
						</td>
						<td>{{ item.refId }}</td>
						<td>{{ item.adType }}</td>
						<td>{{ item.displayCount }}</td>
						<td>{{ item.actionCount }}</td>
						<td>{{ item.actionRate }}</td>
						<td>{{ item.createdAt }}</td>
						<td>{{ item.updatedAt }}</td>
						<td>
							<button
								class="btn blue"
								type="button"
								@click="
									viewAdDetailTotal(
										`${item.title} - ${item.adType}`,
										item.id
									)
								"
							>
								보기
							</button>
						</td>
					</tr>
				</tbody>
				<tbody v-else>
					<tr>
						<td :colspan="thList.length">리스트가 없습니다.</td>
					</tr>
				</tbody>
			</table>
			<PaginationBox
				v-if="parsedAds.length"
				slot="pagination"
				@to="paging"
				:totalItem="totalItem"
				:offset="getOffset"
				:limit="limit"
				:pageLengPerOne="10"
			/>
		</ManagingSection>
	</article>
</template>

<script>
	import { mapState, mapGetters } from 'vuex';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import PaginationBox from '@/components/PaginationBox.vue';
	import moment from 'moment';
	import SearchByEnter from '@/components/extends/SearchByEnter.vue';

	export default {
		name: 'AdsList',
		components: {
			ManagingSection,
			ManagingBox,
			PaginationBox,
			SearchByEnter,
		},
		extends: SearchByEnter,
		data() {
			return {
				ad_code: null,
				keyword: '',
				limit: 50,
				page: 1,
				totalItem: 0,
				thList: [
					'#',
					'제목',
					'참조ID',
					'노출영역',
					'노출',
					'클릭',
					'클릭율',
					'최초집계시각',
					'마지막집계시각',
					'일별 집계 상세보기',
				],
				ads: [],
			};
		},
		computed: {
			...mapState({
				adCodeTable: state => state.ads.adCodeTable,
				refTypeLink: state => state.ads.refTypeLink,
			}),
			...mapGetters({
				adCodeList: 'ads/adCodeList',
			}),
			parsedAdCodeList() {
				return [{ id: null, name: '전체' }, ...this.adCodeList];
			},
			parsedAds() {
				return this.ads.map(item => {
					const adCodeObj = this.adCodeTable[item.ad_code];
					item.title = item.title ? item.title.trim() : '';
					return {
						id: item.id,
						refId: item.ref_id,
						title: item.title || '-',
						adType: adCodeObj
							? adCodeObj.label
							: item.ad_code || '',
						refType: item.ref_type,
						displayCount: item.display_count,
						actionCount: item.action_count,
						actionRate:
							item.display_count === 0
								? '0.00%'
								: `${((item.action_count / item.display_count).toFixed(4) * 100).toFixed(2)}%`,
						createdAt: moment(new Date(item.created_at)).format(
							'YYYY-MM-DD HH:mm:SS'
						),
						updatedAt: moment(new Date(item.updated_at)).format(
							'YYYY-MM-DD HH:mm:SS'
						),
						adCode: item.ad_code,
					};
				});
			},
			getOffset() {
				return (this.page - 1) * this.limit;
			},
		},
		methods: {
			setFilter() {
				const query = this.$route.query;
				if (query.page) this.page = query.page;
				if (query.ad_code) this.ad_code = query.ad_code;
				if (query.keyword) this.keyword = query.keyword;
			},
			getParams() {
				const params = {
					limit: this.limit,
					page: this.page,
				};
				if (this.keyword) params.keyword = this.keyword;
				if (this.ad_code) params.ad_code = this.ad_code;
				return params;
			},
			setQuery() {
				const query = {};
				if (this.page > 1) query.page = this.page;
				if (this.keyword) query.keyword = this.keyword;
				if (this.ad_code) query.ad_code = this.ad_code;
				this.$router.replace({ query }).catch(err => {
					window.location.reload();
				});
			},
			async getList() {
				try {
					const params = this.getParams();
					const { data } = await this.$axiosAdmin2.get('/api/ad', {
						params,
					});
					this.totalItem = data.row_count;
					this.ads = data.ad;
				} catch (err) {
					console.error(err);
					alert(
						'집계 현황 리스트를 불러오는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			paging({ offset }) {
				this.page = offset / this.limit + 1;
				this.setQuery();
				this.getList();
			},
			search() {
				this.page = 1;
				this.setQuery();
				this.getList();
			},
			viewAdDetailTotal(contsTitle, id) {
				this.$store.commit('modal/toggleModal', {
					id: 'AdDetailTotal',
					contsTitle,
					params: { id },
				});
			},
			async linkTo(refId, refType, adCode) {
				if (refType === 'line_banner') {
					try {
						await this.$axiosAdmin2.get(
							`/api/line-banner/${refId}`
						);
					} catch (err) {
						if (err.response?.status === 400) {
							alert('삭제된 광고입니다.');
						} else {
							alert(
								'서버와의 통신에 실패하였습니다. 개발팀에 문의하세요.'
							);
						}
						return;
					}

					if (adCode === 'GP0042') {
						refType = 'mainLineBanner';
					} else if (
						adCode === 'GP0043' ||
						adCode === 'GP0049' ||
						adCode === 'GP0048'
					) {
						refType = 'eventLineBanner';
					} else if (adCode === 'GP0044') {
						refType = 'productLineBanner';
					}
				}
				const targetUri = this.refTypeLink[refType];
				if (!targetUri) {
					alert(
						`${refType}는 설정되지 않은 타입입니다. 개발팀에 문의하세요.`
					);
					return;
				}
				const link = targetUri.replace('${refId}', refId);
				const domain =
					link.indexOf('/') === 0
						? ''
						: this.$store.state.env.adminDomain;
				window.open(`${domain}${link}`, '_blank');
			},
		},
		async created() {
			await this.$store.dispatch('ads/initData');
			this.setFilter();
			await this.getList();
		},
	};
</script>
